import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BookingSection = ({ business, onAuthRequired }) => {
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('');

  const handleBooking = () => {
    const isAuthenticated = localStorage.getItem('authToken');
    
    if (!isAuthenticated) {
      onAuthRequired();
      return;
    }

    // Open external booking link
    if (business?.bookingUrl) {
      window.open(business?.bookingUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const handleTicketPurchase = () => {
    // Direct link to holisticevents.co.uk
    if (business?.ticketUrl) {
      window.open(business?.ticketUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="bg-card rounded-lg p-6">
      <h2 className="text-xl font-heading font-semibold text-foreground mb-6">
        Book Your Session
      </h2>
      {/* Pricing */}
      {business?.pricing && (
        <div className="mb-6">
          <h3 className="text-lg font-heading font-medium text-foreground mb-3">
            Pricing
          </h3>
          <div className="space-y-2">
            {business?.pricing?.map((price, index) => (
              <div key={index} className="flex justify-between items-center">
                <span className="font-body text-foreground">{price?.type}</span>
                <span className="font-body font-semibold text-primary">
                  £{price?.amount}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
      {/* Available Dates */}
      {business?.availableDates && business?.availableDates?.length > 0 && (
        <div className="mb-6">
          <h3 className="text-lg font-heading font-medium text-foreground mb-3">
            Available Dates
          </h3>
          <div className="grid grid-cols-2 gap-2">
            {business?.availableDates?.slice(0, 6)?.map((date, index) => (
              <button
                key={index}
                onClick={() => setSelectedDate(date)}
                className={`p-3 rounded-lg border text-sm font-body transition-gentle ${
                  selectedDate === date
                    ? 'border-primary bg-primary/10 text-primary' :'border-border hover:border-primary/50 text-foreground'
                }`}
              >
                {new Date(date)?.toLocaleDateString('en-GB', {
                  weekday: 'short',
                  day: 'numeric',
                  month: 'short'
                })}
              </button>
            ))}
          </div>
        </div>
      )}
      {/* Available Times */}
      {selectedDate && business?.availableTimes && (
        <div className="mb-6">
          <h3 className="text-lg font-heading font-medium text-foreground mb-3">
            Available Times
          </h3>
          <div className="grid grid-cols-3 gap-2">
            {business?.availableTimes?.map((time, index) => (
              <button
                key={index}
                onClick={() => setSelectedTime(time)}
                className={`p-2 rounded-lg border text-sm font-body transition-gentle ${
                  selectedTime === time
                    ? 'border-primary bg-primary/10 text-primary' :'border-border hover:border-primary/50 text-foreground'
                }`}
              >
                {time}
              </button>
            ))}
          </div>
        </div>
      )}
      {/* Booking Actions */}
      <div className="space-y-3">
        {business?.bookingUrl && (
          <Button
            variant="default"
            fullWidth
            onClick={handleBooking}
            iconName="Calendar"
            iconPosition="left"
            iconSize={16}
          >
            Book Now
          </Button>
        )}

        {business?.ticketUrl && (
          <Button
            variant="outline"
            fullWidth
            onClick={handleTicketPurchase}
            iconName="ExternalLink"
            iconPosition="right"
            iconSize={16}
          >
            Buy Tickets on HolisticEvents
          </Button>
        )}

        {business?.phone && (
          <Button
            variant="secondary"
            fullWidth
            onClick={() => window.open(`tel:${business?.phone}`)}
            iconName="Phone"
            iconPosition="left"
            iconSize={16}
          >
            Call to Book
          </Button>
        )}
      </div>
      {/* Booking Notes */}
      {business?.bookingNotes && (
        <div className="mt-6 p-4 bg-muted rounded-lg">
          <div className="flex items-start space-x-2">
            <Icon name="Info" size={16} className="text-primary mt-0.5 flex-shrink-0" />
            <p className="text-sm font-body text-foreground">
              {business?.bookingNotes}
            </p>
          </div>
        </div>
      )}
      {/* Cancellation Policy */}
      {business?.cancellationPolicy && (
        <div className="mt-4 p-4 bg-warning/10 border border-warning/20 rounded-lg">
          <div className="flex items-start space-x-2">
            <Icon name="AlertTriangle" size={16} className="text-warning mt-0.5 flex-shrink-0" />
            <div>
              <h4 className="font-body font-medium text-foreground mb-1">
                Cancellation Policy
              </h4>
              <p className="text-sm font-body text-foreground">
                {business?.cancellationPolicy}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingSection;